import { render, staticRenderFns } from "./VirtualStationPoint.vue?vue&type=template&id=b35ced04&scoped=true"
import script from "./VirtualStationPoint.vue?vue&type=script&lang=js"
export * from "./VirtualStationPoint.vue?vue&type=script&lang=js"
import style0 from "./VirtualStationPoint.vue?vue&type=style&index=0&id=b35ced04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35ced04",
  null
  
)

export default component.exports